import Home from '../views/Home/Home.vue'
import Play from '../views/Play/Play.vue'
import { RouteComponent } from "vue-router";
// import Result from '../views/Result/Result.vue'




export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/play',
    name: 'play',
    component: Play
  },
  {
    path: '/Result',
    name: 'Result',
    component: (): Promise<RouteComponent> => import('../views/Result/Result.vue')
  },
  {
    path: '/Form',
    name: 'Form',
    component: (): Promise<RouteComponent> => import('../views/Form/Form.vue')
  },
  {
    path: '/LuckydrawResult',
    name: 'LuckydrawResult',
    component: (): Promise<RouteComponent> => import('../views/LuckydrawResult/LuckydrawResult.vue')
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect:'/'
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]